import {
  Button,
  Col,
  Create,
  Form,
  Input,
  Row,
  SaveButton,
  Select,
  Typography,
  useForm,
  useSelect,
} from "@pankod/refine-antd";
import {
  IResourceComponentsProps,
  useNavigation,
  useNotification,
} from "@pankod/refine-core";
import { PasswordRevealModal } from "components/modals";
import { IPartnerUser } from "interfaces";
import { FC, useState } from "react";
import { extractApiErrorMessage } from "utils/utils";

export const PartnerUsersCreate: FC<IResourceComponentsProps> = () => {
  const { goBack } = useNavigation();
  const { open } = useNotification();
  const [generatedPassword, setGeneratedPassword] = useState<string | null>(null);

  const { selectProps: partnerSelectProps } = useSelect({
    resource: "v1/partners",
    optionLabel: "partner_name",
    optionValue: "partner_code",
  });

  const { formProps, saveButtonProps } = useForm<IPartnerUser>({
    errorNotification: false,
    successNotification: false,
    onMutationSuccess: (data) => {
      const password = data.data.generated_password;
      if (password) {
        setGeneratedPassword(password);
      }
    },
    onMutationError: (error) => {
      const message = extractApiErrorMessage(error);
      open?.({
        type: "error",
        description: "Erro ao criar usuário parceiro!",
        message,
      });
    },
  });

  return (
    <>
      <Create
        title="Novo Usuário Parceiro"
        footerButtons={() => (
          <Row gutter={16}>
            <Col>
              <Button onClick={() => goBack()} style={{ minWidth: "92px" }}>
                Cancelar
              </Button>
            </Col>
            <Col>
              <SaveButton {...saveButtonProps} icon={null} style={{ minWidth: "92px" }}>
                Salvar
              </SaveButton>
            </Col>
          </Row>
        )}
      >
        <Form {...formProps} layout="vertical">
          <Form.Item
            label="Nome"
            name="name"
            rules={[{ required: true, message: "Informe o nome" }]}
          >
            <Input placeholder="Nome completo" />
          </Form.Item>

          <Form.Item
            label="Username"
            name="username"
            rules={[{ required: true, message: "Informe o username" }]}
          >
            <Input placeholder="Username de acesso" />
          </Form.Item>

          <Form.Item
            label="Parceiros"
            name="partners"
            rules={[{ required: true, message: "Selecione ao menos um parceiro" }]}
          >
            <Select
              {...partnerSelectProps}
              mode="multiple"
              placeholder="Selecione os parceiros"
            />
          </Form.Item>

          <Typography.Text type="secondary">
            A senha será gerada automaticamente pelo sistema.
          </Typography.Text>
        </Form>
      </Create>

      <PasswordRevealModal
        open={Boolean(generatedPassword)}
        password={generatedPassword ?? ""}
        onClose={() => {
          setGeneratedPassword(null);
          goBack();
        }}
      />
    </>
  );
};
